import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var TrophySVG = function TrophySVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M22.54 17.9c8.7-2.11 7.38-11 7.37-11.06a1 1 0 00-1-.84H24V5a2 2 0 00-2-2H10a2 2 0 00-2 2v1H3.08a1 1 0 00-1 .84c0 .09-1.33 9 7.37 11.06 1.33 2.39 3.4 4.47 5.57 5a.61.61 0 00-.02.1v5h-5a1 1 0 000 2h12a1 1 0 000-2h-5v-5a.61.61 0 000-.13c2.14-.5 4.22-2.59 5.54-4.97zM24 13V8h4a7.49 7.49 0 01-4.41 7.45A8.42 8.42 0 0024 13zM4 8h4v5a8.55 8.55 0 00.41 2.45A7.47 7.47 0 014 8zm15.33 3.13L18 12.53l.25 1.94c.06.46-.22.66-.63.45L16 14.07l-1.66.85c-.41.21-.69 0-.63-.45l.29-1.94-1.29-1.4c-.31-.34-.19-.68.26-.76l1.77-.37.88-1.73c.21-.4.55-.4.76 0l.88 1.73 1.81.34c.45.11.57.45.26.79z"
  }));
};
TrophySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TrophySVG);